import { Button, Col, Form, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Select from "react-select"

export default function ZoneForm({state, handleInputChange, submit, isAddingOrEditing, isRegistering, farmOptions = []}) {
	const { t } = useTranslation()

	const farms = farmOptions?.map(farm => ({
		value: farm._id,
		label: farm.name
	}));

	const typeOptions = [
		{ value: 'nave', label: t('admin.zone.type_nave') },
		{ value: 'parcela', label: t('admin.zone.type_parcela') },
		{ value: 'cercado', label: t('admin.zone.type_cercado') },
		{ value: 'pastizal', label: t('admin.zone.type_pastizal') },
		{ value: 'monte', label: t('admin.zone.type_monte') }
	]

	return (
		<Form onSubmit={submit} className="px-4 formulario">
			<Row className="my-2">
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.zone.name')}</Form.Label>
						<Form.Control
							type="text"
							name="name"
							value={state.name || ''}
							onChange={handleInputChange}
							required
						/>
					</Form.Group>
				</Col>
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.zone.type')}</Form.Label>
						<Select
							options={typeOptions}
							value={typeOptions.find(o => o.value === state.type)}
							onChange={option => handleInputChange({ target: { name: 'type', value: option.value } })}
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row className="my-2">
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.zone.surface')}</Form.Label>
						<Form.Control
							type="number"
							name="surface"
							value={state.surface || ''}
							onChange={handleInputChange}
							min="0"
						/>
					</Form.Group>
				</Col>
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.zone.farm')}</Form.Label>
						<Select
							options={farms}
							value={state.farm ? farms?.find(option => option.value === state.farm._id) : null}
							onChange={option => handleInputChange({ target: { name: 'farm', value: option.value } })}
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row className="my-2">
				<Col xs={12}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.zone.notes')}</Form.Label>
						<Form.Control
							as="textarea"
							rows={3}
							name="notes"
							value={state.notes || ''}
							onChange={handleInputChange}
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col xs={12} lg={6} className="my-2 ms-auto">
					<Button variant='primary' type="submit" className="w-100 my-2">
					{isRegistering ?
						<>
							<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
						</>
					:
						isAddingOrEditing === 'editing' ?
							<>{t('admin.zone.edit')}</>
						:
							<>{t('admin.zone.register')}</>
					}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}
